export default {"src":"/uk/_next/static/media/moneyStacksIcon.c231c5aa.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};